<template>
  <div id="wrapper">
    <nav class="navbar">
      <div class="navbar-brand">
        <router-link to="/jobs" class="navbar-item"><strong>SCE Electrical</strong></router-link>

        <a class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbar-menu" @click="showMobileMenu = !showMobileMenu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div class="navbar-menu" id="navbar-menu" v-bind:class="{'is-active': showMobileMenu }">
        <div class="navbar-end">
          
          <template v-if="isAuthenticated">
            <router-link to="/jobs" class="navbar-item">Find Job</router-link>

            <div class="navbar-item navmenu">
              <div class="dropdown" :class="{'is-active': isOpen, 'is-right': !showMobileMenu}">
                <div class="dropdown-trigger">
                  <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" @click="isOpen = !isOpen">
                    <span>Welcome, {{ currentUserName }}</span>
                    <span class="icon is-small">
                      <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <router-link to="/my-account" v-slot="{ isActive }"><a class="dropdown-item" :class="{'is-active': isActive}">My account</a></router-link>
                    <router-link v-if="isAdmin" to="/admin" v-slot="{ isActive }"><a class="dropdown-item" :class="{'is-active': isActive}">Admin</a></router-link>

                    <hr class="dropdown-divider" />
                      <router-link to="/logout"><a class="dropdown-item">Log out</a></router-link>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="navbar-item">
              <div class="buttons">
                <router-link to="/login" class="button is-light">Log in</router-link>
              </div>
            </div>
          </template>
          
        </div>
      </div>
    </nav>

    <div class="is-loading-bar has-text-centered" v-bind:class="{'is-loading': $store.state.isLoading}">
      <div class="lds-dual-ring"></div>
    </div>
    
    <section class="section main-content">
      <router-view/>
    </section>

    <footer class="footer">
      <p class="has-text-centered">Copyright © 2026</p>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated
    },
    ...mapGetters(['currentUserName']),
    ...mapGetters(['isAdmin'])
  },
  data() {
    return {
      showMobileMenu: false,
      isOpen: false,
    }
  },
  beforeCreate() {
    this.$store.commit('initializeStore')

    const token = this.$store.state.token

    if (token) {
      axios.defaults.headers.common['Authorization'] = "Token " + token
    } else {
      delete axios.defaults.headers.common['Authorization']
    }

    document.title = 'SCE Electrical'
  }
}
</script>

<style lang="scss">
html,
body,
#app {
  min-height: 100vh;
}
#wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
}
.fa-search {
  color: #fff;
}
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after{
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #ccc;
  border-color: #ccc transparent #ccc transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring{
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.is-loading-bar {
  height: 0;
  overflow: hidden;

  -webkit-transition: all 0.3s;
  transition: all 0.3s;

  &.is-loading {
    height: 80px;
  }
}
</style>
